import axios from "axios";
import { store } from "../redux/store/index";
import { USER_LOGOUT } from "../../src/redux/actions/actionType"
import { useNavigate } from "react-router-dom";
import { toastify } from "../components/Toast";

const baseURL = process.env.REACT_APP_API_URL
const config = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "69420"
  },
};

const makePostRequest = (URL, data, multiPartBody) => {
  return new Promise((resolve, reject) => {
    const globalState = store.getState();
    config.headers[
      "Authorization"
    ] = `Bearer ${globalState?.authentication?.token}`;
    if (multiPartBody) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    if (!multiPartBody) {
      config.headers["Content-Type"] = "application/json";
    }
    
    axios
      .post(baseURL + URL, multiPartBody ? data : { ...data }, config)

      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          resolve(response.data);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          store.dispatch({ type: USER_LOGOUT, user: null });
          const navigate = useNavigate();
          navigate("/login");
          toastify("error", "Your session has expired");
          return;
        } else {
          reject(err);
        }
      });

    return baseURL;
  });
};

const makeGetRequest = (URL) => {
  return new Promise((resolve, reject) => {
    const globalState = store.getState();
    config.headers[
      "Authorization"
    ] = `Bearer ${globalState?.authentication?.token}`;
    axios
      .get(baseURL + URL, config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          store.dispatch({ type: USER_LOGOUT, user: null });
          const navigate = useNavigate();
          navigate("/login");
          toastify("error", "Your session has expired");
          return;
        } else {
          reject(err);
        }
      });
  });
};

const makePutRequest = (URL, data) => {
  return new Promise((resolve, reject) => {
    const globalState = store.getState();
    config.headers["Authorization"] = globalState?.authentication?.token;
    axios
      .put(baseURL + URL, data, config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          store.dispatch({ type: USER_LOGOUT, user: null });
          const navigate = useNavigate();
          navigate("/login");
          toastify("error", "Your session has expired");
          return;
        } else {
          reject(err);
        }
      });
  });
};

const makeDeleteRequest = (URL) => {
  return new Promise((resolve, reject) => {
    const globalState = store.getState();
    config.headers[
      "Authorization"
    ] = `Bearer ${globalState?.authentication?.token}`;
    axios
      .delete(baseURL + URL, config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          store.dispatch({ type: USER_LOGOUT, user: null });
          const navigate = useNavigate();
          navigate("/login");
          toastify("error", "Your session has expired");
          return;
        } else {
          reject(err);
        }
      });
  });
};

const makePatchRequest = (URL, data) => {
  return new Promise((resolve, reject) => {
    const globalState = store.getState();
    config.headers[
      "Authorization"
    ] = `Bearer ${globalState?.authentication?.token}`;
    config.headers["Content-Type"] = "application/json";
    axios
      .patch(baseURL + URL, { ...data }, config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          store.dispatch({ type: USER_LOGOUT, user: null });
          const navigate = useNavigate();
          navigate("/login");
          toastify("error", "Your session has expired");
          return;
        } else {
          reject(err);
        }
      });
  });
};

export {
  makeGetRequest,
  makePostRequest,
  makeDeleteRequest,
  makePutRequest,
  makePatchRequest,
};
